import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import QuarterlyReportMiniatureComponent from './QuarterlyReportMiniature.component';
import {
  getDocumentImage,
  GetDocumentImageAction
} from 'src/actions/project/get-document-image/GetDocumentImage.actions';
import {
  downloadDocument,
  DownloadDocumentAction
} from 'src/actions/project/download-document/DownloadDocument.actions';
import QuarterlyReport from 'src/entities/QuarterlyReport';

interface StateProps {
  image?: File;
}

interface OwnProps {
  quarterlyReport: QuarterlyReport;
}

interface DispatchProps {
  getDocumentImage: (documentId: number, imageUrl: string) => Promise<GetDocumentImageAction>;
  download: (document: string, id: number, download: boolean) => Promise<DownloadDocumentAction>;
}

interface Props extends StateProps, OwnProps, DispatchProps {
}

class QuarterlyReportMiniatureContainer extends React.Component<Props> {

  public componentDidMount(): void {
    this.props.getDocumentImage(this.props.quarterlyReport.id, this.props.quarterlyReport.imageUrl);
  }

  public render(): React.ReactNode {
    if (!this.props.image) {
      return null;
    }

    return (
      <QuarterlyReportMiniatureComponent
        quarterlyReport={this.props.quarterlyReport}
        image={this.props.image}
        download={() => this.props.download(this.props.quarterlyReport.url, this.props.quarterlyReport.id, false)}
      />
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    getDocumentImage: (documentId: number, imageUrl: string): Promise<GetDocumentImageAction> => {
      return dispatch(getDocumentImage(documentId, imageUrl));
    },
    download: (document: string, id: number, download: boolean): Promise<DownloadDocumentAction> => {
      return dispatch(downloadDocument(document, id, download));
    }
  };
};

const mapStateToProps: (state: RootState, ownProps: OwnProps) => StateProps = (state: RootState, ownProps: OwnProps):
  StateProps => ({
  image: state.getDocumentImage.images[ownProps.quarterlyReport.id]
});

export default connect(mapStateToProps, mapDispatchToProps)(QuarterlyReportMiniatureContainer);


// WEBPACK FOOTER //
// ./src/modules/project/partials/quarterly-reports/QuarterlyReportMiniature.container.tsx